import { ApplicationElement, html } from '@beunity/lit-components';
import { classMap } from 'lit/directives/class-map.js';

import translations from './translations.js';
import style from './style.lit.css';

import { StoreController } from '@beunity/lit-components/lib/lit/store_controller.js';
import { computedChatsStore } from '@beunity/lit-components/components/chat/lib/chats.store.js';

/**
 * TODO: Description
 *
 * @prop exampleProp - TODO: description
 *
 * @slot default - TODO: description
 * @slot namedSlot - TODO: description
 */

export default class ChatsIndex extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    muted: { type: Boolean },
    showFilters: { type: Boolean },
    kindFilter: { type: String },
    titleFilter: { type: String },
  };

  /** @internal */
  static translations = translations;

  storeController = new StoreController(this, computedChatsStore);

  constructor() {
    super();
    this.kindFilter = '';
    this.muted = false;
    this.showFilters = false;
  }

  get store() {
    return this.storeController.value;
  }

  get unreadCounters() {
    return this.store.unreadCounters;
  }

  get chatList() {
    return this.querySelector('ef-chat-list');
  }

  connectedCallback() {
    super.connectedCallback();

    this.filterLinks = document.querySelectorAll('.filter-bar a');

    document.addEventListener('click', this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('click', this);
  }

  handleEvent(e) {
    e.type === 'click' && this.handleClickFilterLinks(e);
  }

  get searchInput() {
    return this.querySelector('input');
  }

  handleClickFilterLinks(e) {
    const target = e.target.closest('a, button');
    if (!target) return;

    const acceptableParent = target.closest('.filter-bar');

    if (!acceptableParent) return;

    e.preventDefault();

    const { name } = target;

    this.searchInput.value = '';
    this.titleFilter = '';

    if (name === 'muted') {
      this.muted = true;
      this.kindFilter = null;
    } else {
      this.muted = false;
      this.kindFilter = name;
    }
  }

  firstUpdated() {
    const chat = this.store.chats.get(this.store.activeChatId);
    if (chat) this.muted = chat.isMuted;
  }

  willUpdate(_prevChanges) {
    if (this.store.counters.muted === 0 && this.muted) {
      this.muted = false;
    }

    if (this.chatList) {
      this.chatList.muted = this.muted;
      this.chatList.kindFilter = this.kindFilter;
      this.chatList.titleFilter = this.titleFilter;
    }
    this.updateExternalFilterLinks();
  }

  handleSearch(e) {
    this.searchValue = e.target.value;
    this.titleFilter = e.target.value;
  }

  handleSubmit(e) {
    e.preventDefault();
    console.log(e);
  }

  updateExternalFilterLinks() {
    if (!this.filterLinks.length) return;

    const { unreadCounters, counters } = this.store;

    this.filterLinks.forEach(el => {
      const badge = el.querySelector('ef-badge');

      const { name } = el;

      if (name === 'muted') {
        this.setPillActive(el, this.muted);
      } else {
        this.setPillActive(el, name === this.kindFilter);
      }

      if (name === '') {
        badge.count = unreadCounters.allWithoutMuted;
      } else if (name === 'muted') {
        el.classList.toggle('hidden', !counters.muted);
        badge.count = unreadCounters.muted;
      } else if (name === 'group') {
        el.classList.toggle('hidden', !counters.group);
        badge.count = unreadCounters.group;
      } else if (name === 'direct,multi') {
        const unreadCount = unreadCounters.direct + unreadCounters.multi;
        const count = counters.direct + counters.multi;
        el.classList.toggle('hidden', !count);
        badge.count = unreadCount;
      }
    });
  }

  renderFilters() {
    return html`
      <div
        class="filter-bar"
        @click=${this.handleClickFilterLinks}
        ?hidden=${!this.store.hasMutedChats}>
        <button
          class=${classMap({
            'bu-btn': true,
            'btn-outline-dark': this.muted,
            'btn-primary': !this.muted,
          })}>
          <span>${this.t('all')}</span>
          <ef-badge
            theme="primary"
            count=${this.store.unreadCounters.allWithoutMuted}></ef-badge>
        </button>

        <button
          name="muted"
          class=${classMap({
            'bu-btn': true,
            'btn-outline-dark': !this.muted,
            'btn-primary': this.muted,
          })}>
          <span>${this.t('muted')}</span>
          <ef-badge
            theme="primary"
            count=${this.store.unreadCounters.muted}></ef-badge>
        </button>
      </div>
    `;
  }

  setPillActive(el, shouldBeActive) {
    const pill = el.classList.contains('bu-btn') ? el : null;
    if (!pill) return;

    pill.classList.toggle('btn-primary', shouldBeActive);
    pill.classList.toggle('btn-outline-dark', !shouldBeActive);
  }

  render() {
    return html`
      <header>
        <slot
          name="header"
          @input=${this.handleSearch}
          @change=${this.handleSearch}></slot>
      </header>

      ${this.showFilters ? this.renderFilters() : null}
      <slot></slot>
    `;
  }
}

ChatsIndex.registerTagName('bu-chats-index');

customElements.get('bu-chats-index') ||
  customElements.define('bu-chats-index', ChatsIndex);
